import React from 'react'

const React_Coding_Practice_10 = () => {
  return (
    <div>
      <h1>Coding Pratice 10</h1>
    </div>
  )
}

export default React_Coding_Practice_10
